'use client';

/** Synchronous payload fan-out for shell-owned streams. Subscriptions own no transport. */
export function createModuleEmitter<T>() {
  const subscribers = new Set<(event: T) => void>();
  return {
    subscribe(fn: (event: T) => void): () => void {
      subscribers.add(fn);
      return () => { subscribers.delete(fn); };
    },
    emit(event: T): void {
      for (const fn of [...subscribers]) {
        try { fn(event); } catch { /* one dead subscriber never stops the fan-out */ }
      }
    },
  };
}
